module.exports = __webpack_public_path__ + "img/921_part1_image2_pc.23406403.jpg";